import { createSlice } from '@reduxjs/toolkit';

const protectedTimeSlice = createSlice({
  name: 'protectedTime',
  initialState: {
    records: [],
    loading: false,
    error: null,
    filters: {
      userName: 'All', // Default to showing all engineers
    },
  },
  reducers: {
    setRecords: (state, action) => {
      state.records = action.payload;
      state.loading = false;
      state.error = null;
    },
    addRecord: (state, action) => {
      state.records.push(action.payload);
    },
    updateRecord: (state, action) => {
      const index = state.records.findIndex(record => record.ID === action.payload.ID);
      if (index !== -1) {
        state.records[index] = action.payload;
      }
    },
    deleteRecord: (state, action) => {
      state.records = state.records.filter(record => record.ID !== action.payload);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setFilter: (state, action) => {
      const { key, value } = action.payload;
      state.filters[key] = value;
    },
    clearRecords: (state) => {
      state.records = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setRecords,
  addRecord,
  updateRecord,
  deleteRecord,
  setLoading,
  setError,
  setFilter,
  clearRecords,
} = protectedTimeSlice.actions;

export const selectProtectedTimeRecords = (state) => state.protectedTime.records;
export const selectProtectedTimeLoading = (state) => state.protectedTime.loading;
export const selectProtectedTimeError = (state) => state.protectedTime.error;
export const selectProtectedTimeFilters = (state) => state.protectedTime.filters;

export default protectedTimeSlice.reducer;
